import { createFileRoute } from '@tanstack/react-router';

import { WorkspaceOrganizationListScreen } from '@/features/organizations/components/workspace/OrganizationListScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/workspace/organizations/')({
  beforeLoad: () => {
    requirePermission('org:read');
  },
  component: WorkspaceOrganizationListScreen,
  staticData: { crumb: 'Organizations' },
});
